import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './page.module.scss';

type Props = {
  classNames?: string;
};

export const Page: FC<Props> = ({ children, classNames = '' }) => (
  <div className={classnames(styles.page, classNames)} data-reference="page">
    {children}
  </div>
);

export const PageMobile: FC<Props> = ({ children, classNames = '' }) => (
  <div
    className={classnames(styles.pageMobile, classNames)}
    data-reference="page"
  >
    {children}
  </div>
);

export const PageLeft: FC<Props> = ({ children, classNames = '' }) => (
  <div className={classnames(styles.left, classNames)}>{children}</div>
);

export const PageCenter: FC<Props> = ({ children, classNames = '' }) => (
  <div className={classnames(styles.center, classNames)}>{children}</div>
);

export const PageRight: FC<Props> = ({ children, classNames = '' }) => (
  <div className={classnames(styles.right, classNames)}>{children}</div>
);
